import type {TFunction} from 'i18next';
import {z} from 'zod';

export const form300Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        otherHomeLang: z.coerce
            .string({message: `${t('requiredErrorFull')}`})
            .transform(str => str === 'true'),
        otherHomeLangName: z.string().nullish(),
        otherStudentLang: z.coerce
            .string({message: `${t('requiredErrorFull')}`})
            .transform(str => str === 'true'),
        otherStudentLangName: z.string().nullish(),
    });

export const form300Refine = (
    schema: ReturnType<typeof form300Schema>,
    t: TFunction<'translation', undefined>,
) => {
    return schema
        .refine(
            formData => {
                return formData.otherHomeLang ? !!formData.otherHomeLangName : true;
            },
            {
                message: `${t('sef300OtherLang')} is required.`,
                path: ['otherHomeLangName'],
            },
        )
        .refine(
            formData => {
                return formData.otherStudentLang ? !!formData.otherStudentLangName : true;
            },
            {
                message: `${t('sef300OtherLang')} is required.`,
                path: ['otherStudentLangName'],
            },
        );
};
